<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form :model="query" label-width="90px" inline size="mini">
      <el-form-item label="登录账号">
        <el-input v-model="query.loginName" clearable placeholder="请输入登录账号"></el-input>
      </el-form-item>
      <el-form-item label="手机号码">
        <el-input v-model="query.cellphone" clearable placeholder="请输入手机号码"></el-input>
      </el-form-item>
      <el-form-item label="用户状态">
        <el-select v-model="query.state" clearable placeholder="请选择用户状态">
          <el-option label="正常" value="1"></el-option>
          <el-option label="封禁" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
      <!-- <el-button class="reloadBtn" type="warning" size="mini" @click="reload">刷新资源</el-button> -->
      <el-button class="addBtn" type="danger" size="mini" @click="addDialogVisible = true">添加用户</el-button>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 表格数据展示区域 -->
      <el-table :data="userList" style="width: 100%" height="650px" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="loginName" label="登录账号"></el-table-column>
        <el-table-column prop="nickname" label="用户昵称" width="150"></el-table-column>
        <el-table-column prop="cellphone" label="用户手机号" width="150"></el-table-column>
        <el-table-column label="账号类型" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isSystem === 1">系统账号</el-tag>
            <el-tag type="warning" v-else>普通账号</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="账号状态" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state === 1">正常</el-tag>
            <el-tag type="danger" v-else>封禁</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
        <el-table-column label="操作" width="350">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="set(scope.row)">角色分配</el-button>
            <el-button v-if="scope.row.state === 1" type="danger" size="small" @click="stateChange(scope.row)" >封禁用户</el-button>
            <el-button v-else type="success" size="small" @click="stateChange(scope.row)">解禁用户</el-button>
            <el-button :disabled="scope.row.isSystem === 1" type="primary" size="small" @click="resetPasswod(scope.row)">重置密码</el-button>
            <el-button :disabled="scope.row.isSystem === 1" type="danger" size="small" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 添加用户对话框 -->
    <el-dialog title="添加账号" :visible.sync="addDialogVisible" @close="close('addFormRef')" width="35%">
      <el-form :model="addInfo" :rules="addRules" ref="addFormRef" label-width="100px" label-position="left">
        <el-form-item label="用户昵称" prop="nickname">
          <el-input v-model="addInfo.nickname"></el-input>
        </el-form-item>
        <el-form-item label="用户手机号" prop="cellphone">
          <el-input v-model="addInfo.cellphone" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="登录账号" prop="loginName">
          <el-input v-model="addInfo.loginName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="insertUser">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="配置角色" :visible.sync="setRoleDialogVisible" width="35%" height="80%">
      <el-checkbox-group v-model="rolecheck">
        <el-checkbox v-for="(role, index) in roleList" :key="index" :label="role.uuid" :disabled="role.disabled == 1" border>{{role.name}}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setRoleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setRole">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { userQuery, userInsert, userDelete, userReset, userState, userRoleBinding, userRoleList } from '@/API/authority'
export default {
  name: 'sysUser',
  data() {
    return {
      query: {
        curPage: 1,
        pageSize: 10,
        loginName: '',
        cellphone: '',
        state: ''
      },
      // 用户列表
      userList: [],
      roleList: [],
      rolecheck: [],
      // 数据总条数
      total: 0,
      // 添加用户对话框是否显示
      addDialogVisible: false,
      // 添加用户表单数据
      addInfo: {
        loginName: '',
        cellphone: '',
        nickname: ''
      },
      // 表单验证规则
      addRules: {
        loginName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
        cellphone: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }]
      },
      setRoleDialogVisible: false,
      setInfo: {
        userUuid: '',
        roleUuids: []
      }
    }
  },
  created() {
    this.queryUserList()
  },
  methods: {
    async queryUserList() {
      const { data: res } = await userQuery(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.userList = res.data.entities
      this.total = res.data.totalSize
    },
    // 重置按钮点击事件
    custody() {
      this.query = {
        curPage: 1,
        pageSize: 10
      }
      this.queryUserList()
    },
    // 搜索按钮点击事件
    seach() {
      this.query.curPage = 1
      this.queryUserList()
    },
    // 监听pageSize
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.queryUserList()
    },
    // 监听curPage
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.queryUserList()
    },
    reload() {

    },
    insertUser() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await userInsert(this.addInfo)
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.$refs.addFormRef.resetFields()
        this.queryUserList()
        this.addDialogVisible = false
      })
    },
    del(row) {
      this.$confirm('是否删除此账号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await userDelete({
          uuid: row.uuid
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.queryUserList()
      })
    },
    // 封禁用户
    stateChange(data) {
      this.$confirm(data.state === 1 ? '是否封禁此账号' : '是否解禁此账号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
          const { data: res } = await userState({
            uuid: data.uuid,
            state: data.state === 1 ? 2 : 1
          })
          if (res.code !== 200) return this.$message.error(res.message)
          this.$message.success(res.message)
          this.queryUserList()
        })
    },
    resetPasswod(row) {
      this.$confirm('是否重置此账号密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await userReset({
          uuid: row.uuid
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
      })
    },
    async set(row) {
      this.rolecheck = []
      const { data: res } = await userRoleList({ userUuid: row.uuid })
      if (res.code !== 200) return this.$message.error(res.message)
      this.setInfo.userUuid = row.uuid
      this.roleList = res.data
      for (let n in this.roleList) {
        let role = this.roleList[n]
        if (role.owner === 1) {
          this.rolecheck.push(role.uuid)
        }
      }
      this.setRoleDialogVisible = true
    },
    setRole() {
      this.setInfo.roleUuids = []
      if (this.rolecheck.length === 0) {
        this.$message.error('请选择角色')
      }
      this.setInfo.roleUuids = this.rolecheck
      this.$confirm('是否确认配置角色', '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      ).then(async () => {
        const { data: res } = await userRoleBinding(this.setInfo)
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.setRoleDialogVisible = false
      })
    },
    close(formRef) {
      this.$refs[formRef].resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.resetBtn {
  margin-left: 50px;
}
.reloadBtn {
  float: right;
  margin-right: 50px;
}
</style>
